import * as angular from "angular";
import * as _ from "lodash";
import {BringozToastService} from "../../commons/services/bringoz-toast.service";

export class PricePlanAlertsService {

  constructor(private bringozToastService: BringozToastService) {
  }

  // CREATE //
  createSuccess() {
    const message = {
      body: 'PRICE_PLAN_CREATE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }


  createError() {
    const message = {
      body: 'PRICE_PLAN_CREATE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // UPDATE //
  updateSuccess() {
    const message = {
      body: 'PRICE_PLAN_UPDATE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }


  updateError() {
    const message = {
      body: 'PRICE_PLAN_UPDATE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // UPDATE PREFERENCES //
  updatePreferencesSuccess() {
    const message = {
      body: 'PRICE_PLAN_UPDATE_PREFERENCES_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }


  updatePreferencesError() {
    const message = {
      body: 'PRICE_PLAN_UPDATE_PREFERENCES_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  updatePreferencesOriginMissingLocationsWarning(origin) {
    const message = {
      body: 'PRICE_PLAN_UPDATE_PREFERENCES__ORIGIN_MISSING_LOCATIONS_WARNING',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.warning(message, origin)
  }

  // UPDATE ZONE //
  updateZoneSuccess() {
    const message = {
      body: 'PRICE_PLAN_UPDATE_ZONE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }


  updateZoneError() {
    const message = {
      body: 'PRICE_PLAN_UPDATE_ZONE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }


  updateServiceTimeSuccess() {
    const message = {
      body: 'PRICE_PLAN_UPDATE_SERVICE_TIME_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }


  updateSpecialDaySuccess() {
    const message = {
      body: 'PRICE_PLAN_UPDATE_SPECIAL_DAY_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  // SET DEFAULT //
  setDefaultSuccess() {
    const message = {
      body: 'PRICE_PLAN_SET_DEFAULT_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }


  setDefaultError() {
    const message = {
      body: 'PRICE_PLAN_SET_DEFAULT_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // DUPLICATE //
  duplicateSuccess() {
    const message = {
      body: 'PRICE_PLAN_DUPLICATE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }


  duplicateError() {
    const message = {
      body: 'PRICE_PLAN_DUPLICATE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // UP TO DATE //
  upToDateInfo() {
    const message = {
      body: 'PRICE_PLAN_UP_TO_DATE_INFO'
    };
    return this.bringozToastService.success(message)
  }

  // STATE VALIDATION //
  stateValidationError() {
    const message = {
      body: 'PRICE_PLAN_STATE_VALIDATION_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // ADD_PROGRAM_TYPE //
  addProgramTypeSuccess() {
    const message = {
      body: 'PRICE_PLAN_ADD_PROGRAM_TYPE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }


  addProgramTypeError() {
    const message = {
      body: 'PRICE_PLAN_ADD_PROGRAM_TYPE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // UPDATE_PROGRAM_TYPE //
  updateProgramTypeSuccess() {
    const message = {
      body: 'PRICE_PLAN_UPDATE_PROGRAM_TYPE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }


  updateProgramTypeError() {
    const message = {
      body: 'PRICE_PLAN_UPDATE_PROGRAM_TYPE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message);
  }

  // GET_ADDITIONS //
  getAdditionError() {
    const message = {
      body: 'PRICE_PLAN_GET_ADDITIONS_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message);
  }

  // CREATE_ADDITION //
  createAdditionSuccess() {
    const message = {
      body: 'PRICE_PLAN_CREATE_ADDITION_SUCCESS'
    };
    return this.bringozToastService.success(message);
  }


  createAdditionError() {
    const message = {
      body: 'PRICE_PLAN_CREATE_ADDITION_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message);
  }

  // UPDATE_ADDITION //
  updateAdditionSuccess() {
    const message = {
      body: 'PRICE_PLAN_UPDATE_ADDITION_SUCCESS'
    };
    return this.bringozToastService.success(message);
  }


  updateAdditionError() {
    const message = {
      body: 'PRICE_PLAN_UPDATE_ADDITION_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message);
  }

  // DELETE_ADDITION //
  deleteAdditionSuccess() {
    const message = {
      body: 'PRICE_PLAN_DELETE_ADDITION_SUCCESS'
    };
    return this.bringozToastService.success(message);
  }


  deleteAdditionError() {
    const message = {
      body: 'PRICE_PLAN_DELETE_ADDITION_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message);
  }


  getPackageItemsError() {
    const message = {
      body: 'PRICE_PLAN_GET_ITEMS_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  //CREATE_PACKAGE_ITEM
  createPackageItemSuccess() {
    const message = {
      body: 'PRICE_PLAN_CREATE_PACKAGE_ITEM_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  createPackageItemError() {
    const message = {
      body: 'PRICE_PLAN_CREATE_PACKAGE_ITEM_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  //UPDATE_PACKAGE_ITEM
  updatePackageItemSuccess() {
    const message = {
      body: 'PRICE_PLAN_UPDATE_PACKAGE_ITEM_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  updatePackageItemError() {
    const message = {
      body: 'PRICE_PLAN_UPDATE_PACKAGE_ITEM_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  //UPDATE_DEFAULT_PACKAGE_ITEM
  updateDefaultPackageItemSuccess() {
    const message = {
      body: 'PRICE_PLAN_UPDATE_DEFAULT_PACKAGE_ITEM_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  updateDefaultPackageItemError() {
    const message = {
      body: 'PRICE_PLAN_UPDATE_DEFAULT_PACKAGE_ITEM_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }


  updateLineSplitConfigurationSuccess() {
    const message = {
      body: 'UPDATE_LINE_SPLIT_CONFIGURATION_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  updateLineSplitConfigurationError() {
    const message = {
      body: 'UPDATE_LINE_SPLIT_CONFIGURATION_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  getServiceValidationsError() {
    const message = {
      body: 'GET_SERVICE_VALIDATIONS_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  createServiceValidationSuccess() {
    const message = {
      body: 'CREATE_SERVICE_VALIDATION_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  createServiceValidationError() {
    const message = {
      body: 'CREATE_SERVICE_VALIDATION_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  updateServiceValidationSuccess() {
    const message = {
      body: 'UPDATE_SERVICE_VALIDATION_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  updateServiceValidationError() {
    const message = {
      body: 'UPDATE_SERVICE_VALIDATION_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  deleteServiceValidationSuccess() {
    const message = {
      body: 'DELETE_SERVICE_VALIDATION_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  deleteServiceValidationError() {
    const message = {
      body: 'DELETE_SERVICE_VALIDATION_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  programCodeExistsError() {
    const message = {
      body: 'PROGRAM_CODE_EXISTS_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // EXPORT //
  exportSuccess() {
    const message = {
      body: 'PRICE_PLAN_EXPORT_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  exportError() {
    const message = {
      body: 'PRICE_PLAN_EXPORT_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // IMPORT PROGRAM SETTINGS //
  importProgramSettingsSuccess() {
    const message = {
      body: 'IMPORT_ENTITIES_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  importProgramSettingsError(error?) {
    const message = {
      body: 'IMPORT_ENTITIES_ERROR',
      details: 'SOMETHING_WENT_WRONG',
      message: _.get(error, 'more_info')
    };
    return this.bringozToastService.error(message)
  }

  // DELIVERY DAYS VALIDATION //
  daysNotSelectedInfo() {
    const message = {
      body: 'DAYS_NOT_SELECTED'
    };
    return this.bringozToastService.info(message)
  }

  intervalNotSetInfo() {
    const message = {
      body: 'INTERVAL_NOT_SET'
    };
    return this.bringozToastService.info(message)
  }

  serviceAreasNotSelectedInfo() {
    const message = {
      body: 'SERVICE_AREAS_NOT_SELECTED'
    };
    return this.bringozToastService.info(message)
  }

}

angular
  .module('bringoz.admin.pricePlan')
  .service('pricePlanAlertsService', PricePlanAlertsService);
